import React, {useEffect, useMemo, useState} from 'react'
import {Autocomplete, TextField} from '@mui/material'
import {useSelector} from 'react-redux'
import {getOfficeList} from 'utils/apiCalling/api'
import useOfficeHierarchy from 'utils/hooks/useOfficeHierarchy'
import {uniqueOfficeList} from 'utils/validation/validation'

/**
 * @param setSubmitData useState setState
 * @param submitData  useState Value
 * @param register react-hook-from register
 * @param setValue react-hook-from setValue (errors 지우는 용)
 * @param name react-hook-from (register에 name을
 *
 *
 */
const CustomerRegisterSearch = (props: any) => {
  const {setSubmitData, submitData, register, setValue, name, errors} = props
  const [officeList, setOfficeList] = useState<any>(null)
  const userInfo = useSelector((state: any) => state.userInfo?.userInfo)
  /* uniqueOfficeList 는 매 렌더마다 새 배열을 만들어 계층 계산이 반복되므로 메모한다 */
  const uniqueList = useMemo(() => uniqueOfficeList(officeList), [officeList])
  const officeHierarchy = useOfficeHierarchy(uniqueList)
  useEffect(() => {
    getOfficeList(userInfo, setOfficeList)
  }, [])
  return (
    <>
      {officeList && (
        <>
          <Autocomplete
            disablePortal
            fullWidth
            options={officeHierarchy.options}
            onChange={(event, value: any) => {
              setSubmitData({
                ...submitData,
                officeId: value?.value ?? '',
                officeName: value?.label ?? '',
              })
              /* 목록에서 고른 값만 폼 값으로 인정한다 (직접 입력한 글자는 반영하지 않음) */
              setValue(name, value?.label ?? '', {shouldValidate: true})
            }}
            clearText={'초기화'}
            noOptionsText={'검색 결과가 없습니다.'}
            getOptionLabel={(option: any) => option.label}
            filterOptions={officeHierarchy.filterOptions}
            renderOption={officeHierarchy.renderOption}
            renderInput={(params) => (
              <div className={'d-flex gap-3'}>
                <TextField
                  {...params}
                  label='사업소 검색'
                  error={errors[name] ? true : false}
                  helperText={
                    errors[name] ? (
                      <span className={'fs-6 fw-bold text-danger'}>
                        {String(errors[name].message)}
                      </span>
                    ) : (
                      ''
                    )
                  }
                />
                {/* Autocomplete 입력창에 register 를 직접 붙이면 타이핑만으로 필수검증이 통과되므로
                    실제 폼 값은 선택 시에만 채워지는 hidden 필드가 들고 있는다 */}
                <input
                  type='hidden'
                  {...register(name, {
                    required: {
                      value: true,
                      message: '필수 입력 사항입니다.',
                    },
                  })}
                />
              </div>
            )}
          />
          <TextField
            required
            id='customer-id'
            // label='사업소 코드'
            placeholder={'사업소 코드가 자동으로 입력됩니다.'}
            variant='outlined'
            disabled
            fullWidth
            value={
              submitData?.officeName ? submitData?.officeName + '-' + submitData?.officeId : '-'
            }
          />
        </>
      )}
    </>
  )
}

export default CustomerRegisterSearch
